import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official'

import './MarketPricingChart.scss';

type Props = {
  pricedJobsCount: number
  slottedJobsCount: number
  neitherJobsCount: number
  chartInteraction: (name: string) => void
}

const MarketPricingChart = ({ pricedJobsCount, slottedJobsCount, neitherJobsCount, chartInteraction }: Props) => {
  const options: Highcharts.Options = {
    chart: {
      type: 'column',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      width: 400,
      height: 225
    },
    xAxis: {
      lineColor: '#d3d3d3',
      tickLength: 0,
      categories: ['Priced', 'Slotted', 'Neither'],
      labels: {
        style: {
          color: '#fff',
          fontSize: '14px'
        }
      }
    },
    yAxis: {
      tickPixelInterval: 75,
      title: {
        text: ''
      },
      labels: {
        style: {
          color: '#fff',
          fontSize: '14px'
        }
      }
    },
    credits: {
      enabled: false
    },
    title: { text: '' },
    plotOptions: {
      column: {
        pointWidth: 60,
        pointPadding: 20,
        groupPadding: 0
      }
    },
    tooltip: {
      style: {
        fontSize: '16px',
      }
    },
    series: [
      {
        type: 'column',
        animation: true,
        cursor: 'pointer',
        borderRadius: 0,
        name: '',
        borderColor: '',
        label: {
          enabled: false
        },
        showInLegend: false,
        point: {
          events: {
            click: (e) => chartInteraction(e.point.name.toLowerCase()),
          }
        },
        data: [
          { name: 'Priced', color: '#68fffa', y: parseInt(pricedJobsCount.toString(), 10) },
          { name: 'Slotted', color: '#68fffa', y: parseInt(slottedJobsCount.toString(), 10) },
          { name: 'Neither', color: '#68fffa', y: parseInt(neitherJobsCount.toString(), 10) }
        ]
      }
    ]
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export default MarketPricingChart;
